export default __webpack_public_path__ + "media/color/wtc-18a1969e.svg";